module.exports = __webpack_public_path__ + "img/talent_01.d7ea55d4.png";